<template>
    <div class="contractoragreementPg px-[20px] py-[50px] tablet:p-[50px] font-roboto bg-[#FDF9EE]" v-html="updateContractorAgreementDetails.terms_and_conditions_text"></div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters([
            "updateContractorAgreementDetails"
        ]),
    },
    mounted() {
        this.getContractorAgreementDetails()
    },
    methods: {
        ...mapActions([
            "getContractorAgreementDetails"
        ]),
    }
};
</script>
